import { CommonModule } from '@angular/common';
import { Component, Injector, Input } from '@angular/core';
import { NavigationExtras, Params, Router } from '@angular/router';
import { AppComponentBase } from '@shared/common/app-component-base';

export class BreadcrumbItem {
	text: string;
	routerLink?: string;
	navigationExtras?: NavigationExtras;

	constructor(text: string, routerLink?: string, navigationExtras?: NavigationExtras) {
		this.text = text;
		this.routerLink = routerLink;
		this.navigationExtras = navigationExtras;
	}

	isLink(): boolean {
		return !!this.routerLink;
	}
}

@Component({
	selector: 'sub-header',
	templateUrl: './sub-header.component.html',
	standalone: true,
	imports: [CommonModule],
})
export class SubHeaderComponent extends AppComponentBase {
	@Input() title: string;
	@Input() description: string;
	@Input() titleLink: string;
	@Input() titleLinkQueryParams: Params;
	@Input() breadcrumbs: BreadcrumbItem[];

	constructor(
		private _router: Router,
		injector: Injector
	) {
		super(injector);
	}

	isLinkTitle(): boolean {
		return !!this.titleLink;
	}

	goToTitleLink() {
		if (!this.titleLink) {
			return;
		}

		if (!this.titleLinkQueryParams) this._router.navigate([this.titleLink]);
		else this._router.navigate([this.titleLink], { queryParams: this.titleLinkQueryParams });
	}

	goToBreadcrumb(breadcrumb: BreadcrumbItem): void {
		if (!breadcrumb.routerLink) {
			return;
		}

		if (breadcrumb.navigationExtras) {
			this._router.navigate([breadcrumb.routerLink], breadcrumb.navigationExtras);
		} else {
			this._router.navigate([breadcrumb.routerLink]);
		}
	}
}
